var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import history from 'helpers/History';
import { Table } from 'components';
import { loading } from 'elements/Loading';
var PacketsTable = /** @class */ (function (_super) {
    __extends(PacketsTable, _super);
    function PacketsTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleSelectItem = function (value) {
            history.push("/packets/".concat(value.id));
        };
        _this.handleCreate = function () {
            history.push("/packets/create");
        };
        _this.mapea = function (stretches, operationLines) {
            return stretches.map(function (item) {
                var operationLine = operationLines.filter(function (ol) {
                    return ol.id === item.operationLine_id;
                })[0];
                var operationLineString = 'operationLine';
                item[operationLineString] = operationLine ? operationLine.name : '';
                // console.log('item', item)
                return item;
            });
        };
        return _this;
    }
    PacketsTable.prototype.componentDidMount = function () {
    };
    PacketsTable.prototype.render = function () {
        var packetStore = this.props.store.packetStore;
        var operationLines = this.props.store.operationLines;
        var headers = ['name', 'code', 'operationLine', 'disabled_at', 'description'];
        var filters = [
            {
                name: 'all',
                filter: function (item) { return true; }
            },
            {
                name: 'actives',
                filter: function (item) { return item.disabled_at === null; }
            },
            {
                name: 'disabled',
                filter: function (item) { return item.disabled_at !== null; }
            },
        ];
        var mapeados = this.mapea(packetStore.data, operationLines.data);
        // console.log('mapeados', mapeados)
        if (!(operationLines.data.length > 0))
            return React.createElement("div", null,
                React.createElement("text", null, "No hay lineas de operaci\u00F3n, por favor cree una antes"),
                " ");
        return (React.createElement(Table, { filters: filters, items: mapeados, header: headers, onSelectItem: this.handleSelectItem, onCreate: this.handleCreate, keyExtractor: function (item) { return String(item.id); }, loading: !packetStore.loaded }));
    };
    PacketsTable = __decorate([
        inject('store'),
        loading(function (props) {
            return [
                props.store.packetStore.read(),
                props.store.operationLines.read()
            ];
        }),
        observer
    ], PacketsTable);
    return PacketsTable;
}(Component));
export default PacketsTable;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Packets/container/PacketsTable.tsx
// module id = 1542
// module chunks = 0